var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatantiaTotalLineas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 316.9 309.1",
    style: {
      enableBackground: "new 0 0 316.9 309.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#E30613;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.8,82.5c-1.4-2.5-3.6-4.6-6.4-6.2c-8-4.5-21.4-5.2-38.2-2.4c-0.7,0.1-1.4,0.2-2.2,0.4 c0.4,1.7,0.7,3.5,1.1,5.2c2,0.4,3.8,0.9,5.4,1.7c2.9,1.3,5.1,3.1,6.4,5.5c3.5,6.1,1,15.1-6.1,25.5c-1.7,2.5-3.8,5.1-6,7.8 c-14.1,16.7-38.2,35.9-67.8,52.8c-29.7,16.9-58.6,27.9-80.2,31.5c-5.2,0.9-10,1.3-14.2,1.3c-10.1,0-17.2-2.6-20.3-7.9 c-0.7-1.1-1-2.4-1.3-3.8c-1-5.2,1.1-11.8,5.7-19.2c-0.5-1.2-1-2.4-1.5-3.7c-4.5,4.4-8.5,8.8-12.1,13 c-13.2,15.8-19.5,29.8-16.5,39.6c0.3,1.1,0.7,2.1,1.3,3.1c7.3,12.8,33,13.2,67,3.4c0.8-0.2,1.7-0.5,2.5-0.8 c23.8-7.1,51.4-19,79.6-35c26.1-14.9,49-31.2,66.7-47c0.7-0.6,1.3-1.2,1.9-1.8C278,119.9,292.5,95.9,284.8,82.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.9,189.7c18.8-3.7,43.1-13.1,67.9-27.3c27.8-15.9,50.2-34.1,62.3-49.5l-19.3-46c-2.4-5.8-7.4-9.8-13-11.4 c-0.1,0-0.3-0.1-0.4-0.1l-64.8-21c-4.1-1.3-9.3-0.6-15.7,2.1c-2.9,1.2-5.6,2.8-7.9,4.5c-2.3,1.8-3.9,3.5-4.8,5.2l-30.3,61 c-0.1,0.1-0.1,0.2-0.2,0.4c-2.9,5.1-3.5,11.4-1,17.3L95.9,189.7z M120.2,54.1c4.2-1.8,9,0.2,10.7,4.4s-0.2,9-4.4,10.7 c-4.2,1.8-9-0.2-10.7-4.4C114,60.7,116,55.9,120.2,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.5,151.9c-16.9,14.3-37.8,28.9-61.4,42.4c-24.4,13.9-48.4,24.7-69.9,31.9l15.5,37 c4.2,10,15.8,14.8,25.8,10.5l101.8-42.8c10-4.2,14.8-15.8,10.5-25.8L242.5,151.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatantiaTotalLineas);
export default __webpack_public_path__ + "static/media/gatantia-total-lineas.1f2a613d98e174c2a7928391da1cfecc.svg";
export { ForwardRef as ReactComponent };